module.exports = __webpack_public_path__ + "officialStatic/img/school2Logo.46e354e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/school2Logo.png
// module id = z8um
// module chunks = 0